import { STEPS } from '../../../common/constants'

export const STEPS_DATA = {
  [STEPS.FROM]: { title: 'noun:senderAddress2', subtitle: 'helper:origin' },
  [STEPS.TO]: {
    title: 'noun:recipientAddress2',
    subtitle: 'helper:destination',
  },
  [STEPS.SHIPMENT]: { title: 'noun:shipment', subtitle: 'helper:shipment' },
  [STEPS.SUMMARY]: { title: 'noun:resume', subtitle: 'helper:resume' },
}

export const STEPS_DATA_CUSTOMS = {
  [STEPS.FROM]: { title: 'noun:senderAddress2', subtitle: 'helper:origin' },
  [STEPS.TO]: {
    title: 'noun:recipientAddress2',
    subtitle: 'helper:destination',
  },
  [STEPS.SHIPMENT]: { title: 'noun:shipment', subtitle: 'helper:shipment' },
  [STEPS.CUSTOMS]: { title: 'noun:customs', subtitle: 'helper:customs' },
  [STEPS.SUMMARY]: { title: 'noun:resume', subtitle: 'helper:resume' },
}
